import React from "react";
import LegalPageLayout from "../components/subComponents/LegalPageLayout";

function TermsAndConditions() {
	return (
		<LegalPageLayout title="Terms and Conditions" lastUpdated="September 2026">
			<p className="legalIntro">
				By using this website, you agree to these terms. If you don't
				agree, please don't use the site. Questions can be sent to{" "}
				<a href="mailto:info.gcasregina@gmail.com">
					info.gcasregina@gmail.com
				</a>
				.
			</p>

			<section className="legalSection">
				<h2 className="legalSectionHeading">About this site</h2>
				<p>
					This site is published by GCAS Regina, the Ghanaian-Canadian
					Association of Saskatchewan, Regina, to share information about
					our community, gatherings, and events.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Event information</h2>
				<p>
					Event details, including dates, times, venues, and prices, are
					entered by our volunteers and are subject to change. We make a
					good-faith effort to keep this information accurate but can't
					guarantee it. If an event's details matter to your plans, please
					confirm them with us directly before making arrangements.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">No online purchases</h2>
				<p>
					This site doesn't process payments or sell tickets. Where an
					event lists a price, payment is arranged directly with GCAS
					Regina or its organizers, off this site, such as by e-transfer
					or in person.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">External links</h2>
				<p>
					This site links to external services we don't control,
					including WhatsApp, social media platforms, Google Maps, and
					sponsor or venue websites. We aren't responsible for their
					content or practices.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Content and copyright</h2>
				<p>
					Photos, text, and other content on this site belong to GCAS
					Regina or are used with permission, unless stated otherwise.
					Please don't reproduce or redistribute this content without
					asking us first.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">No warranty</h2>
				<p>
					This site is provided "as is." We do our best to keep it
					accurate and available, but we don't guarantee it will be
					error-free or uninterrupted.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Limitation of liability</h2>
				<p>
					To the extent permitted by law, GCAS Regina isn't liable for any
					loss or damage arising from your use of this site.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Governing law</h2>
				<p>These terms are governed by the laws of Saskatchewan, Canada.</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Changes to these terms</h2>
				<p>
					We may update these terms as the site changes. The date above
					reflects the most recent update.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Contact us</h2>
				<p>
					Questions about these terms? Email{" "}
					<a href="mailto:info.gcasregina@gmail.com">
						info.gcasregina@gmail.com
					</a>
					.
				</p>
			</section>
		</LegalPageLayout>
	);
}

export default TermsAndConditions;
